export default __webpack_public_path__ + "static/invimatic-iso-more-news-5-245f775df3752dcf96a4b9e60f3a38dc.png";